export default __webpack_public_path__ + "static/media/chair.031371a3.png";